<template>
  <div>
    <v-dialog max-width="90%" v-if="!loading" :value="value" @input="$emit('input', $event)">
      <v-form @submit.prevent="$v.setUp.$invalid ? null : submit()" ref="setUp">
        <v-card class="pb-3 neu-glow">
            <v-card-title class="text-h5 mb-0">
              Setup Iniziale
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-3" disabled color="success" @click="dialog_reset=true"> 
                    <v-icon color="error">mdi-restart</v-icon>
                  </v-btn>
                </template>
                <span>Reset</span>
              </v-tooltip> 
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-3" color="success" :disabled="!validEmail" :loading="loading_create" @click="dialog_confirm=true"> 
                    <v-icon color="success">mdi-creation</v-icon>
                  </v-btn>
                </template>
                <span>Configura</span>
              </v-tooltip>               
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-3" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip> 
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-3" @click="dialog_tutorial=true">
                    <v-icon color="info">mdi-cast-education</v-icon>
                  </v-btn>
                </template>
                <span>Tutorial</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-3" @click.native="loading_update=false;$emit('input', false)">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Esci</span>
              </v-tooltip>                            
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-3 mt-2">
              <v-col cols="8">
                <v-card class="neu-glow">
                  <v-card-title>
                    Credenziali d'accesso
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon fab x-small class="neu-glow mr-3" color="success" @click="helpLevel=3;dialog_instruction=true">
                          <v-icon color="info">mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Istruzioni</span>
                    </v-tooltip>                      
                  </v-card-title>
                  <v-card-text class="pt-0">
                    <v-row class="py-0">
                      <v-col cols="6">
                        <v-text-field
                          :error-messages="fieldErrors('setUp.email').length>0?fieldErrors('setUp.email'):null"
                          @input="$v.setUp.email.$touch()"
                          label="Email"
                          outlined
                          autocomplete="username"
                          color="info"
                          prepend-inner-icon="email"
                          v-model="setUp.email"
                          :rules="emailRules"
                          ref="email"
                          name="email"                                                           
                          counter="40"
                          hint="Email per il Login"
                        >
                        </v-text-field>  
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          :error-messages="fieldErrors('setUp.password').length>0?fieldErrors('setUp.password'):null"
                          label="Password"
                          outlined
                          autocomplete="new-password"
                          color="info"
                          v-model="setUp.password"
                          :rules="passwordRules"
                          :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showPwd ? 'text' : 'password'"
                          @input="$v.setUp.password.$touch()"
                          @blur="$v.setUp.password.$touch()"
                          @click:append="showPwd = !showPwd"
                        > 
                        <v-icon slot="prepend-inner" :color="setUp.password?setUp.password.length>13?'success':setUp.password.length>9?'warning':'error':'grey'">{{setUp.password&&setUp.password.length>9?'mdi-lock':'mdi-lock-open'}}</v-icon>
                        </v-text-field>                          
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card class=" neu-glow">
                  <v-card-title>
                    Cellulare Amministratore
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon fab x-small class="neu-glow mr-3" color="success" @click="helpLevel=2;dialog_instruction=true">
                          <v-icon color="info">mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Istruzioni</span>
                    </v-tooltip>                      
                  </v-card-title>
                  <v-card-text class="pt-0">
                      <v-text-field
                        :error-messages="fieldErrors('setUp.mobile').length>0?fieldErrors('setUp.mobile'):null"
                        label="Cellulare Admin"
                        prepend-inner-icon="mdi-cellphone"
                        outlined
                        color="info"
                        v-model="setUp.mobile"
                        :rules="mobileRules"
                      > 
                      </v-text-field>  
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <v-card class=" neu-glow">
                  <v-card-title>
                    Brand
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon fab x-small class="neu-glow mr-3" color="success" @click="helpLevel=4;dialog_instruction=true">
                          <v-icon color="info">mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Istruzioni</span>
                    </v-tooltip>                      
                  </v-card-title>
                  <v-card-text class="pt-0">
                      <v-text-field
                      :error-messages="fieldErrors('setUp.brand').length>0?fieldErrors('setUp.brand'):null"
                        label="Insegna"
                        outlined
                        color="info"
                        v-model="setUp.brand"
                        prepend-inner-icon="mdi-codepen"
                        :rules="brandRules"
                      > 
                      </v-text-field>  
                  </v-card-text>
                </v-card>
              </v-col>                
              <v-col cols="4">
                <v-card class=" neu-glow">
                  <v-card-title>
                    Sito Web
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon fab x-small class="neu-glow mr-3" color="success" @click="helpLevel=1;dialog_instruction=true">
                          <v-icon color="info">mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Istruzioni</span>
                    </v-tooltip>                      
                  </v-card-title>
                  <v-card-text class="pt-0">
                      <v-text-field
                        label="Indirizzo Sito Web"
                        prepend-inner-icon="mdi-web"
                        outlined
                        color="info"
                        :rules="websiteRules"
                        v-model="setUp.websiteURL"
                      > 
                      </v-text-field>  
                  </v-card-text>
                </v-card>
              </v-col>            
              <v-col cols="5">
                <v-card class="neu-glow">
                  <v-card-title>
                    URI
                    <v-spacer></v-spacer>
                    <div class="text-center">
                      <span class="font-weight-black" :class="setUp.subdomain&&setUp.subdomain.length>4?'info--text':'error--text'" v-html="setUp.subdomain?setUp.subdomain:'xxx'"></span>
                      <span class="font-weight-black blue--text">.ibookrestaurant.com</span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon fab x-small class="neu-glow mr-3" color="success" @click="helpLevel=5;dialog_instruction=true">
                          <v-icon color="info">mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Istruzioni</span>
                    </v-tooltip>                      
                  </v-card-title>
                  <v-card-text class="pt-0">
                    <v-text-field
                      :error-messages="fieldErrors('setUp.subdomain').length>0?fieldErrors('setUp.subdomain'):null"
                      @input="$v.setUp.subdomain.$touch()"
                      prepend-inner-icon="mdi-sitemap"
                      name="subdomain"
                      :rules="subdomainRules"
                      ref="subdomain"
                      v-model="setUp.subdomain"
                      label="Dominio III Livello"
                      outlined
                      autocomplete="off"
                      suffix=".ibookrestaurant.com"
                      color="info"
                    >
                    </v-text-field>
                  </v-card-text>
                </v-card>
              </v-col>                            
              <v-col cols="8">
                <v-card class=" neu-glow pb-5">
                  <v-card-title>
                    Chiusura Settimanale
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon fab x-small class="neu-glow mr-3" color="success" @click="helpLevel=0;dialog_instruction=true">
                          <v-icon color="info">mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Istruzioni</span>
                    </v-tooltip>                      
                  </v-card-title>
                  <v-card-text>Pranzo</v-card-text>
                  <v-btn-toggle v-model="setUp.closedOnLunch" multiple active-class="info white--text" class="d-inline">
                    <v-row class="mx-3">
                      <v-col v-for="(d,d2) in allDays||[]" :key="d2" class="py-2">
                        <v-btn 
                          small
                          :value="d.DOW"
                          block
                        >
                        {{d.GDS}}</v-btn>
                      </v-col>
                    </v-row>
                  </v-btn-toggle> 
                  <v-card-text>Cena</v-card-text>
                  <v-btn-toggle v-model="setUp.closedOnDinner" multiple active-class="info white--text" class="d-inline">
                    <v-row class="mx-3">
                      <v-col v-for="(d,d2) in allDays||[]" :key="d2" class="py-2">
                        <v-btn 
                          small
                          :value="d.DOW"
                          block
                        >
                        {{d.GDS}}</v-btn>
                      </v-col>
                    </v-row>
                  </v-btn-toggle>                    
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card class=" neu-glow pb-5">
                  <v-card-title>
                    Carica dati Demo/Reali
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon fab x-small class="neu-glow mr-3" color="success" @click="helpLevel=6;dialog_instruction=true">
                          <v-icon color="info">mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Istruzioni</span>
                    </v-tooltip>                      
                  </v-card-title>
                  <v-btn-toggle v-model="setUp.demo" mandatory active-class="info white--text" class="d-inline">
                    <v-row class="mx-3">
                      <v-col v-for="(d,d2) in [{type:'Demo',value:0},{type:'Reali',value:1}]" :key="d2" class="py-2">
                        <v-btn 
                          small
                          :value="d.value"
                          block
                        >
                        {{d.type}}</v-btn>
                      </v-col>
                    </v-row>
                  </v-btn-toggle>  
                </v-card>
              </v-col>              
            </v-row>
            <v-row class="mx-3">
              
              <v-col cols="12" lg="12" v-for="(c,ci) in classes" :key="ci">
                <v-card class="neu-glow mt-3">
                  <v-card-title class="mb-3">
                    {{c}}
                  </v-card-title>
                  <v-card-text>
                    <v-card class="neu-glow my-3">
                      <v-row class="mx-2" v-for="(i,ii) in items.filter(i=>i.class==c)" :key="ii">
                        <v-col cols="11" v-if="i.dataType=='nvarchars'" class="d-flex align-center">
                            <v-text-field   
                              dense
                              counter
                              :label="i.description"
                              outlined
                              :name="i.optionId"

                              :reverse="i.dataType!='nvarchar'"
                              v-model="i.value"
                              persistent-placeholder
                              hide-details
                              :readonly="!i.editableByUser"
                            >
                            </v-text-field>
                        </v-col>
                        <template v-else>
                          <v-col cols="8" class="d-flex align-center">
                            {{i.description}}
                          </v-col>
                          <v-col cols="3" class="d-flex align-center">
                            <template v-if="i.inputType=='switch'">
                              <v-switch
                                color="info"
                                dense
                                v-model="i.value"
                                inset
                                :label="i.value?'Si':'No'"
                                hide-details
                                :readonly="!i.editableByUser"
                                class="mt-0 pt-0"
                              ></v-switch>                      
                            </template>
                            <template v-else-if="i.inputType=='textarea'">
                              <v-textarea   
                                counter
                                dense
                                label=""
                                outlined
                                :name="i.optionId"
                                v-model="i.value"
                                persistent-placeholder
                                hide-details
                              >
                              </v-textarea>                              
                            </template>
                            <template v-else-if="i.inputType=='select'">
                              <v-select
                                dense
                                label=""
                                outlined
                                :items="i.acceptedValues.split(',')||[]"
                                :name="i.optionId"
                                v-model="i.value"
                                persistent-placeholder
                                hide-details
                              >
                              </v-select>                              
                            </template>                            
                            <template v-else>
                              <v-text-field   
                                counter
                                dense
                                label=""
                                outlined
                                :name="i.optionId"
                                :reverse="i.dataType!='nvarchar'"
                                v-model="i.value"
                                persistent-placeholder
                                hide-details
                                :readonly="!i.editableByUser"
                              >
                              </v-text-field>                          
                            </template>
                          </v-col>
                        <v-col cols="1" class="d-flex align-center">
                          <v-tooltip max-width="250" top v-if="i.help||!i.editableByUser">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on"  color="info">mdi-help-circle</v-icon>
                            </template>
                            <span v-html="!i.editableByUser?'Sola Lettura':i.help"></span>
                          </v-tooltip>                          
                        </v-col>                                                
                      </v-row>
                    </v-card>
                  </v-card-text>
                </v-card>
              </v-col>
              
              <!--
              <masonry-wall :items="classes"  scroll-container="scrollContainer" :gap="16" :minColumns="2" :maxColumns="2" class="mx-4">
                <template #default="{ item }">
                  <v-card class="neu-glow mb-3">
                    <v-card-title class="mb-3">
                      {{item}}
                    </v-card-title>
                    <v-card-text>
                      <v-card class="neu-glow my-3">
                        <v-row class="mx-2" v-for="(i,ii) in items.filter(i=>i.class==item)" :key="ii">
                          
                          <v-col cols="11" v-if="i.dataType=='nvarchar'" class="d-flex align-center">
                              <v-text-field   
                                dense
                                counter
                                :label="i.description"
                                outlined
                                :name="i.optionId"
                                @input.native="save"
                                :reverse="i.dataType!='nvarchar'"
                                v-model="i.value"
                                persistent-placeholder
                                hide-details
                                :readonly="!i.editableByUser"
                              >
                              </v-text-field>
                          </v-col>
                          <template v-else>
                            <v-col cols="8" class="d-flex align-center">
                              {{i.description}}
                            </v-col>
                            <v-col cols="3" class="d-flex align-center">
                              <template v-if="i.dataType=='bit'">
                                <v-switch
                                  color="info"
                                  dense
                                  v-model="i.value"
                                  inset
                                  @change="save2($event, i.optionId)"
                                  :label="i.value?'Si':'No'"
                                  hide-details
                                  :readonly="!i.editableByUser"
                                  class="mt-0 pt-0"
                                ></v-switch>                      
                              </template>
                              <template v-else>
                                <v-text-field   
                                  dense
                                  counter
                                  @input.native="save"
                                  label=""
                                  outlined
                                  :name="i.optionId"
                                  :reverse="i.dataType!='nvarchar'"
                                  v-model="i.value"
                                  persistent-placeholder
                                  hide-details
                                  :readonly="!i.editableByUser"
                                >
                                </v-text-field>                          
                              </template>
                            </v-col>
                          <v-col cols="1" class="d-flex align-center">
                            <v-tooltip max-width="250" top v-if="i.help||!i.editableByUser">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on"  color="info">mdi-help-circle</v-icon>
                              </template>
                              <span v-html="!i.editableByUser?'Sola Lettura':i.help"></span>
                            </v-tooltip>                          
                          </v-col>                                                
                        </v-row>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </template>
              </masonry-wall>
              -->                            
            </v-row>
        </v-card>
      </v-form>
    </v-dialog>  
    <dialog-instruction v-model="dialog_instruction" :helpLevel="helpLevel" />
    <dialog-tutorial v-model="dialog_tutorial"  /> 
    <dialog-confirm @save2="saveItem2" v-model="dialog_confirm"  />  
    <dialog-reset @reset3="reset3" v-model="dialog_reset"  />         
  </div>
</template>
<script>
import { required, email,  minLength, maxLength, alphaNum, numeric } from "vuelidate/lib/validators";
import validationMixin       from "@/mixins/validationMixin";
import dialogInstruction     from "./instruction";
import dialogTutorial        from "./tutorial"
import dialogConfirm         from "./confirm"
import dialogReset           from "./reset"
import { mapGetters }        from "vuex";
export default {
    components:{
      dialogInstruction,dialogTutorial,dialogConfirm,dialogReset
    },
    props:['value','loading'],
    computed : {
      ...mapGetters(["settings","SST","countries"]),
    },
  mixins: [validationMixin],
  validations: {
    setUp: { 
        mobile: { required, numeric, minLength: minLength(9), maxLength: maxLength(10) },
        password: { required, minLength: minLength(8) },
        brand:{ required, alphaNum, maxLength: maxLength(12)},
        email:{ required, email, async isUnique (value) 
        {
          if (value === '') return true
          if (value.length>4)
          {
              var userToken=localStorage.getItem('userToken')
              var json={"value":value,"action":"check_email","userToken":userToken}
              //json.action='check_VATNumber'
              const response =  await this.update_db(json)
              console.log(221,response);
              //this.VATResponse=response;
              if (response.errorid=='0')
              {
                  this.validEmail=true
                  return true;      
              }
              else
              {
                  this.validEmail=false
                  return false; 
              }
          }
          else
          {
              this.validEmail=false
              return false;
          }
        }},
        websiteURL:{ alphaNum },
        subdomain: { required, minLength: minLength(5) , async isUnique (value) 
        {
          if (value === '') return true
          if (value.length>4)
          {
              var userToken=localStorage.getItem('userToken')
              var json={"value":value,"action":"check_subURL","userToken":userToken}
              //json.action='check_VATNumber'
              const response =  await this.update_db(json)
              console.log(221,response);
              //this.VATResponse=response;
              if (response.errorid=='0')
              {
                  return true;                  
              }
              else
              {
                  return false; 
              }
          }
          else
          {
              return false;
          }
        }
      }
    }
  },
  validationMessages: {
    setUp: {
      mobile: {
        required: 'Inserisci il Numero di Cellulare',
        minLength: 'Minimo 9 cifre',
        maxLength: 'Massimo 10 cifre',
        numeric: 'Solo Numeri'
      },
      password: {
        required: 'Inserisci una Password',
        minLength: 'Minimo 8 Caratteri'
      },
      email: {
        required: 'Inserisci un indirizzo Email',
        email: 'Deve essere un indirizzo Valido',
        isUnique: 'Email già in uso'
      },
      brand: {
        required: 'Inserisci un Marchio',
        maxLength: 'Su cellulare oltre 10 caratteri copre i tasti',
        alphaNum: 'Caratteri AlfaNumerici'
      },
      websiteURL: {
        alphaNum: 'Indirizzo non valido'
      },                  
      subdomain: {
        required: 'Dominio Richiesto',
        minLength: 'Minimo 5 cifre',
        isUnique: 'Dominio già in uso'
      },     
    }             
  },    
    data () {
    return {
      page:'Settings',
      showPwd:false,
      helpLevel:null,
      loading_create:false,
      validEmail:null,
      mobileRules:
      [
        v => !!v || "Il Numero di Cellulare è obbligatorio",
        v => /^[0-9]{9,10}$/.test(v) || "Solo Numeri, minimo 9, massimo 10"
      ],
      websiteRules:
      [
        v => /^(https:\/\/)?(www\.)?[-a-zA-Z0-9@:%._#=]{2,256}\.[a-z]{2,10}(\/)?.?$/.test(v) || "Dominio, anche senza https://www."
      ],
      emailRules:
      [
        v => !!v || "L'email è obbligatoria",
        v => /.+@.+\.[a-z]{2,}/.test(v) || "E-mail must be valid"
      ],
      passwordRules:
      [
        v => !!v || "La password è obbligatoria",
        v => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(v) || "Minimo 8 Caratteri: almeno 1 Numero, 1 Maiuscola, 1 Minuscola, 1 Carattere Speciale"
      ],
      brandRules:
      [
        v => !!v || "L'insegna è obbligatoria",
        v => /^[a-zA-Z0-9 ']{5,12}$/.test(v) || "Lunghezza: 5-12 caratteri: (solo A-Z e/o 0-9)"
      ],      
      subdomainRules:
      [
        v => !!v || "Il Dominio di III Livello è obbligatorio",
        v => /^[a-z0-9]{5,12}$/.test(v) || "Lunghezza: 5-12 caratteri: (solo a-z e/o 0-9)"
      ],       
      setUp:{}, 
      dialog_tutorial:false,
      dialog_instruction:false,
      dialog_confirm:false,
      allDays:[
                {"DOW": 1,"GDS":"Lunedì","short":"LUN"},
                {"DOW":2,"GDS":"Martedì","short":"MAR"},
                {"DOW":3,"GDS":"Mercoledì","short":"MER"},
                {"DOW":4,"GDS":"Giovedì","short":"GIO"},
                {"DOW":5,"GDS":"Venerdì","short":"VEN"},
                {"DOW":6,"GDS":"Sabato","short":"SAB"},
                {"DOW":7,"GDS":"Domenica","short":"DOM"}
              ],
      items:null,
      classes:null,
    }},
    created(){
      //this.getData();
      console.log(295,this.settings)
      this.getData()
      //this.setUp.email=this.settings.email;
    },
    watch:{
      'setUp.brand': function (newVal)
      {
        if(newVal)
        {
          console.log(270,newVal)
          this.$store.dispatch("setTempBrand",newVal);
        }
      },
    },
    methods:
    {
      saveItem2()
      {
        this.setUp.setupToken=sessionStorage.getItem('setupToken');
        //this.setup.accountId=
        this.loading_create=true;
        console.log(658,this.setUp)
        console.log(659,this.items)
        //var merged= items.map(ii=> {return {[ii.optionId]: ii.value}})
        var m = this.items.reduce((obj, item) => (obj[item.optionId] = item.value?item.value:null, obj) ,{});
        console.log(m)
        const merged={...m,...this.setUp}
        console.log(661,merged)
        //this.$emit('setUp',this.setUp);
        this.$emit('save', merged)
      },
      async update_db(payload)
      {
        try
        {
          //const res = await this.$http.post('/settings/settings_write.php', {"fieldname":fieldname,"fieldvalue":fieldvalue});
          //payload.locale=this.locale.substring(0,2);
          let json=JSON.stringify(payload);
          console.log(2100,json);
          const res = await this.$http.post('/auth/signup.php', json);
          console.log(362,'signup',res);
          this.formReadOnly=false;
          if (res.data.errorid=='0')
          {
            if(res.data.jwt)
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              //sessionStorage.setItem('settings', res.data.settings);
            }
            //this.snackbar_color='success';
            console.log(792,res.data);
          }
          else
          {
            this.snackbar_color='error'
            //this.$router.push('/auth/login').catch(() => {});
          }
          //this.message=res.data.message;
          //this.snackbar=true;
          return res.data;
        }
        catch(e)
        {
          console.log(e);
        }
      },         
        
      async getData()
      {
        this.loading=true;
        try{
            const payload=JSON.stringify({"action":"setupParameters_get"});
            const res = await this.$http.post('/settings/settings.php', payload );
            console.log(275,res);            
            switch (res.data.errorid)
            {
              case '0':
                  sessionStorage.setItem('jwt', res.data.jwt);
                  this.items=res.data.payloads.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); return o});
                  this.items_hash=JSON.stringify(this.items);
                  this.classes=[...new Set( this.items.map(obj => obj.class)) ];
                  //this.items==Object.entries(settings).map(([key, value]) => ({key,value}));
                  console.log(315,this.items,res.data.payloads,this.classes)
              break;
              case '0006':
                  this.$router.push('/auth/login').catch(() => {});
              break;
            }
            this.loading= false;
        } catch(e)
        {
            this.loading= false;

        }
      },      
    } 
}
</script>
<style scoped>
.centered-input input {
  text-align: center!important
}
.theme--light.v-input--switch .v-input--switch__track{
  color: #1976d2!important
}
.theme--light.v-input--switch .v-input--switch__thumb{
  color: #1976d2!important
}
</style>